// Fonction utilitaire pour obtenir la couleur en fonction du score
// Nouvelle échelle de couleurs :
// Score ≤ 1 => Faible (vert)
// 1 < Score ≤ 2 => Modéré (jaune)
// 2 < Score ≤ 3 => Élevé (orange)
// Score > 3 => Critique (rouge)

export const getScoreColor = (score) => {
  const numScore = parseFloat(score);

  if (numScore <= 1) {
    return '#2e7d32'; // Vert - Faible
  } else if (numScore <= 2) {
    return '#fbc02d'; // Jaune - Modéré
  } else if (numScore <= 3) {
    return '#ed6c02'; // Orange - Élevé
  } else {
    return '#d32f2f'; // Rouge - Critique
  }
};

export const getScoreLabel = (score) => {
  const numScore = parseFloat(score);

  if (numScore <= 1) {
    return 'Faible';
  } else if (numScore <= 2) {
    return 'Modéré';
  } else if (numScore <= 3) {
    return 'Élevé';
  } else {
    return 'Critique';
  }
};

// Fonction pour formater les nombres avec séparateur de milliers
export const formatNumber = (num) => {
  if (!num || isNaN(num)) return '0';
  const numValue = typeof num === 'string' ? parseFloat(num) : num;
  const rounded = Math.round(numValue);
  // Utiliser une regex pour ajouter des espaces comme séparateurs de milliers
  // Cela évite les problèmes d'encodage avec toLocaleString dans les PDF
  return rounded.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
};
